/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_UnlockedInputs */

const id_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbuka`)
};

const ms_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuka`)
};

const da_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Låst op`)
};

const de_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigeschaltet`)
};

const en_us2_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlocked`)
};

const es_es2_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueados`)
};

const es_mx2_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueados`)
};

const fil_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-unlock`)
};

const fr_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloqués`)
};

const it_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbloccati`)
};

const hu_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feloldva`)
};

const nl_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontgrendeld`)
};

const no_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Låst opp`)
};

const pl_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odblokowane`)
};

const pt_br2_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueado`)
};

const pt_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueadas`)
};

const ro_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deblocate`)
};

const fi_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avattu`)
};

const sv_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upplåsta`)
};

const vi_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã mở khóa`)
};

const tr_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açılan`)
};

const cs_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odemčeno`)
};

const bg_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отключени`)
};

const ru_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыто`)
};

const uk_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розблоковано`)
};

const ar_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الفتح`)
};

const hi_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनलॉक`)
};

const th_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกแล้ว`)
};

const ja_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解除済み`)
};

const zh_cn2_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解锁`)
};

const zh_hant1_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解鎖`)
};

const ko_profile_hero_unlocked = /** @type {(inputs: Profile_Hero_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠금 해제`)
};

/**
* | output |
* | --- |
* | "Unlocked" |
*
* @param {Profile_Hero_UnlockedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_unlocked = /** @type {((inputs?: Profile_Hero_UnlockedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_UnlockedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_unlocked(inputs)
	if (locale === "ms") return ms_profile_hero_unlocked(inputs)
	if (locale === "da") return da_profile_hero_unlocked(inputs)
	if (locale === "de") return de_profile_hero_unlocked(inputs)
	if (locale === "en-US") return en_us2_profile_hero_unlocked(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_unlocked(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_unlocked(inputs)
	if (locale === "fil") return fil_profile_hero_unlocked(inputs)
	if (locale === "fr") return fr_profile_hero_unlocked(inputs)
	if (locale === "it") return it_profile_hero_unlocked(inputs)
	if (locale === "hu") return hu_profile_hero_unlocked(inputs)
	if (locale === "nl") return nl_profile_hero_unlocked(inputs)
	if (locale === "no") return no_profile_hero_unlocked(inputs)
	if (locale === "pl") return pl_profile_hero_unlocked(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_unlocked(inputs)
	if (locale === "pt") return pt_profile_hero_unlocked(inputs)
	if (locale === "ro") return ro_profile_hero_unlocked(inputs)
	if (locale === "fi") return fi_profile_hero_unlocked(inputs)
	if (locale === "sv") return sv_profile_hero_unlocked(inputs)
	if (locale === "vi") return vi_profile_hero_unlocked(inputs)
	if (locale === "tr") return tr_profile_hero_unlocked(inputs)
	if (locale === "cs") return cs_profile_hero_unlocked(inputs)
	if (locale === "bg") return bg_profile_hero_unlocked(inputs)
	if (locale === "ru") return ru_profile_hero_unlocked(inputs)
	if (locale === "uk") return uk_profile_hero_unlocked(inputs)
	if (locale === "ar") return ar_profile_hero_unlocked(inputs)
	if (locale === "hi") return hi_profile_hero_unlocked(inputs)
	if (locale === "th") return th_profile_hero_unlocked(inputs)
	if (locale === "ja") return ja_profile_hero_unlocked(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_unlocked(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_unlocked(inputs)
	return ko_profile_hero_unlocked(inputs)
});
export { profile_hero_unlocked as "profile.hero.unlocked" }